import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@common/encoding';
export class VerifyEmailRequest extends AutoEncoder {
    /**
     * Token that the client received when creating the code or via email link (might decide to drop that last one)
     */
    token;
    code;
}
__decorate([
    field({ decoder: StringDecoder })
], VerifyEmailRequest.prototype, "token", void 0);
__decorate([
    field({ decoder: StringDecoder })
], VerifyEmailRequest.prototype, "code", void 0);
export class PollEmailVerificationRequest extends AutoEncoder {
    /**
     * Token that the client received when creating the code or via email link (might decide to drop that last one)
     */
    token;
}
__decorate([
    field({ decoder: StringDecoder })
], PollEmailVerificationRequest.prototype, "token", void 0);
export class PollEmailVerificationResponse extends AutoEncoder {
    /**
     * Token that the client received when creating the code or via email link (might decide to drop that last one)
     */
    valid;
}
__decorate([
    field({ decoder: BooleanDecoder })
], PollEmailVerificationResponse.prototype, "valid", void 0);
//# sourceMappingURL=VerifyEmailRequest.js.map